
<div class="modal-body">
    <div *ngIf="ShowLoginPage">
            <h4 class="modal-title">Login</h4>
        <form [formGroup]="loginForm"  *ngIf="!ShowOtpForm" (ngSubmit)="onLoginFormSubmit()" class="login-form">
            <div style="color: red;text-align: center;" *ngIf="invalidCred">Invalid Username or Password</div>
            <div style="color: red;text-align: center;" *ngIf="LockedCred">Your account is Locked by NAROLA DIAMONDS PVT LTD </div>
            <div style="color: red;text-align: center;" *ngIf="ActiveCred">Your account is not active by NAROLA DIAMONDS PVT LTD</div>
            <div class="container">
                <div class="user_login">
                    <!-- <h6 class="use_head">Username</h6> -->
                    <h6 class="use_head">Username</h6>

                    <div class="input-group us_grp">
                        <input type="text" placeholder="Username" class="inp_us"
                            formControlName="username">
                        <span class="input-group-addon">
                            <i class="icon-user ncr_icon"></i>
                        </span>
                    </div>
                    <div style="color: red;margin-left: 23%"
                        *ngIf="submitted && username.errors && username.errors.required">Username is
                        required.
                    </div>
                </div>
                <div class="pswd_login">
                    <h6 class="use_head">Password</h6>
                    <div class="input-group us_grp">
                        <input type="password" placeholder="Password" class="inp_us"
                            formControlName="password">
                        <span class="input-group-addon">
                            <i class="icon-key ncr_icon"></i>
                        </span>
                    </div>
                    <div style="color: red;margin-left: 23%;"
                        *ngIf="submitted && password.errors && password.errors.required">Password is
                        required.
                    </div>
                </div>

                <!--<p class="frg" style="cursor: pointer" (click)="forgotPassword()" data-toggle="modal" data-target="#forgotPwdModal">Forgot password?</p>-->
                <a class="cret"
                    (click)="ShowCreateAccount=!ShowCreateAccount;ShowForogtPass=false;ShowLoginPage=false;RegClassAdd()">Create Account</a>
                <p class="frg" style="cursor: pointer"
                    (click)="ShowForogtPass=!ShowForogtPass;ShowLoginPage=false;ShowCreateAccount=false">
                    Forgot password?</p>
                <div class="log_btn">
                    <button type="submit" class="btn btn_login"
                        id="login_user">Login</button>
                    <!--<h5 class="cret" data-toggle="modal" data-target="#myModal3" id="reg_user" >Create Account</h5>-->


                </div>

            </div>
            <div class="event_head">

                <!-- <a class="sidebar-video-container"><img style="object-fit:cover;width:auto;max-width:100%;padding: 0;" src="https://pcknstg.blob.core.windows.net/hdfile/WebBanner/29MAYPOST.jpg/"></a> -->

                <a [innerHtml]="BannerURL" class="sidebar-video-container"></a>


            </div>
        </form>

        <form [formGroup]="OTPForm" *ngIf="ShowOtpForm" (ngSubmit)="onLoginFormSubmitWithOTP()" class="login-form">
            <div style="color: red;text-align: center;" *ngIf="invalidCred">Invalid Username or Password</div>
            <div style="color: red;text-align: center;" *ngIf="LockedCred">Your account is Locked by NAROLA DIAMONDS PVT LTD </div>
            <div style="color: red;text-align: center;" *ngIf="ActiveCred">Your account is not active by NAROLA DIAMONDS PVT LTD</div>
            <div class="container">
                <div class="user_login">
                    <!-- <h6 class="use_head">Username</h6> -->
                    <h6 class="use_head">OTP</h6>

                    <div class="input-group us_grp">
                        <input type="text" placeholder="OTP" class="inp_us"
                            formControlName="OTP">
                        <span class="input-group-addon">
                            <i class="icon-user ncr_icon"></i>
                        </span>
                    </div>
                    <div style="color: red;margin-left: 23%"
                        *ngIf="ShowOtpValidationMsg">OTP is
                        required.
                    </div>
                </div>
 
                <div class="log_btn mt-3">
                    <button type="submit" class="btn btn_login"
                        id="login_user">Login</button>
                </div>

            </div>
            <div class="event_head">
                <a [innerHtml]="BannerURL" class="sidebar-video-container"></a>
            </div>
        </form>

    </div>
    <div *ngIf="ShowForogtPass">
        <h4 class="modal-title" >FORGOT PASSWORD</h4>
        <app-forgot-pass></app-forgot-pass>
    </div>
    <div *ngIf="ShowCreateAccount">
        <h4 class="modal-title" >REGISTER</h4>
        <!-- <app-registration></app-registration> -->
        <app-web-registration></app-web-registration>
    </div>


</div>

<div id="cover" [@ShowHide]="loaderspinning ? 'spinning' : 'stopped'">
    <img src="https://pcknstg.blob.core.windows.net/hdfile/webimg/logo_spin.png" class="img_spin">
</div>
